import React from 'react';

// Compact multi-select of output fields, rendered as toggle chips.
// `fields` is the field schema, `value` the list of selected keys.
export default function FieldChips({ fields, value = [], onChange }) {
  const toggle = (key) => {
    const next = value.includes(key) ? value.filter((k) => k !== key) : [...value, key];
    onChange(next);
  };

  return (
    <div className="field-chips">
      {(fields || []).map((f) => (
        <button
          key={f.key}
          type="button"
          className={value.includes(f.key) ? 'field-chip field-chip-active' : 'field-chip'}
          onClick={() => toggle(f.key)}
        >
          {f.fullLabel || f.label || f.key}
        </button>
      ))}
    </div>
  );
}
